import { render } from "./WithText.vue?vue&type=template&id=241d42d1"
import script from "./WithText.vue?vue&type=script&lang=ts"
export * from "./WithText.vue?vue&type=script&lang=ts"
script.render = render

export default script